import http from "@/utils/http";

export function FileApi(url, data, method) {
  let info = {
    url: "file-service/files/" + url,
    method: method,
  };

  if (method === "GET") {
    info.params = data;
  } else {
    info.data = data;
  }

  return http(info);
}
